import * as React from "react";
import {RentalState} from "./types";
import {classNames} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface RentalStateDisplayProps {
    rentalState: RentalState;
}

export function RentalStateDisplay({rentalState}: RentalStateDisplayProps) {
    const stateStyle = styles[rentalState];
    const {t} = useLocalization();
    return (
        <span className={classNames(styles.badge, stateStyle)}>{t(rentalState)}</span>
    );
}

const styles = stylesheet({
    badge: {
        textAlign: 'center',
        fontSize: '0.75em',
        display: 'inline-block',
        padding: '0.5em 1em',
        lineHeight: '1em',
        height: '2em',
        borderRadius: '25px',
    },
    Created: {
        backgroundColor: '#9E9E9E',
        color: '#FFFFFF'
    },
    BorrowerPickedUp: {
        backgroundColor: '#2B87C4',
        color: '#FFFFFF'
    },
    LenderPickedUp: {
        backgroundColor: '#FFA000',
        color: '#000000'
    },
    LenderReturned: {
        backgroundColor: '#2B87C4',
        color: '#FFFFFF'
    },
    BorrowerReturned: {
        backgroundColor: '#0F5102',
        color: '#FFFFFF'
    },

});
